/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
  AWSEmail: any;
  AWSIPAddress: any;
  AWSJSON: any;
  AWSPhone: any;
  AWSTime: any;
  AWSTimestamp: any;
  AWSURL: any;
};

export type A2sApplicability = {
  __typename?: 'A2sApplicability';
  questions?: Maybe<Array<A2sTemplateQuestion>>;
};

export type A2sMetadataConfiguration = {
  __typename?: 'A2sMetadataConfiguration';
  customMetadata?: Maybe<Array<Maybe<MetadataDefinition>>>;
  excludeOptionalMetadataKeys?: Maybe<Array<Maybe<OptionalAssessmentMetadataKey>>>;
  requiredMetadataKeys?: Maybe<Array<OptionalAssessmentMetadataKey>>;
};

export type A2sPreEventConfiguration = {
  __typename?: 'A2sPreEventConfiguration';
  enabled?: Maybe<Scalars['Boolean']>;
  participantEmailTemplate?: Maybe<EmailTemplate>;
  questions?: Maybe<A2sPreEventQuestionFilter>;
  sponsorEmailTemplate?: Maybe<EmailTemplate>;
};

export type A2sPreEventQuestionFilter = {
  __typename?: 'A2sPreEventQuestionFilter';
  excludeSections?: Maybe<Array<Maybe<Scalars['String']>>>;
  optionToSendAll?: Maybe<Scalars['Boolean']>;
  questionType?: Maybe<Scalars['String']>;
};

export type A2sRatingBand = {
  __typename?: 'A2sRatingBand';
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  lowerBound?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  upperBound?: Maybe<Scalars['Float']>;
};

export type A2sReport = {
  __typename?: 'A2sReport';
  excel?: Maybe<A2sReportConfiguration>;
  heatmap?: Maybe<A2sReportConfiguration>;
  ppt?: Maybe<A2sReportConfiguration>;
  radar?: Maybe<A2sReportConfiguration>;
  report?: Maybe<A2sReportConfiguration>;
  responseDistribution?: Maybe<A2sReportConfiguration>;
  scoreBarChart?: Maybe<A2sReportConfiguration>;
  scores?: Maybe<A2sScoresConfiguration>;
  sectionLabel?: Maybe<Scalars['String']>;
  snapshots?: Maybe<A2sReportConfiguration>;
  word?: Maybe<A2sReportConfiguration>;
};

export type A2sReportConfiguration = {
  __typename?: 'A2sReportConfiguration';
  categoryLabel?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  excludeSections?: Maybe<Array<Maybe<Scalars['String']>>>;
  groupBy?: Maybe<Scalars['String']>;
  sectionLabel?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  useQuestionIndex?: Maybe<Scalars['Boolean']>;
};

export type A2sResultCriteriaConfiguration = {
  __typename?: 'A2sResultCriteriaConfiguration';
  description?: Maybe<Scalars['String']>;
  ratingRange?: Maybe<Array<Maybe<Scalars['Float']>>>;
  summary?: Maybe<Scalars['String']>;
};

export type A2sScoresConfiguration = {
  __typename?: 'A2sScoresConfiguration';
  equalCategoryWeight?: Maybe<Scalars['Boolean']>;
  ignoreIncomplete?: Maybe<Scalars['Boolean']>;
  maxRating?: Maybe<Scalars['Float']>;
  perspectiveWeighted?: Maybe<Scalars['Boolean']>;
  summaryAssessment?: Maybe<A2sSummaryConfiguration>;
};

export type A2sSummaryConfiguration = {
  __typename?: 'A2sSummaryConfiguration';
  name?: Maybe<Scalars['String']>;
  resultCriteria?: Maybe<Array<Maybe<A2sResultCriteriaConfiguration>>>;
};

export type A2sTemplate = {
  __typename?: 'A2sTemplate';
  applicability?: Maybe<A2sApplicability>;
  applicationTitle?: Maybe<Scalars['String']>;
  defaults?: Maybe<A2sTemplateDefaults>;
  deliveryGuidance: A2sTemplateDeliveryGuidance;
  description: Scalars['String'];
  lastUpdated: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  metadataConfig?: Maybe<A2sMetadataConfiguration>;
  section: A2sTemplateSectionWrapper;
  title: Scalars['String'];
  type: Scalars['String'];
  version: Scalars['String'];
  workstreams?: Maybe<Array<A2sTemplateWorkstream>>;
};

export type A2sTemplateActivity = {
  __typename?: 'A2sTemplateActivity';
  id: Scalars['ID'];
  name: Scalars['String'];
  phase?: Maybe<Scalars['String']>;
};

export type A2sTemplateCategory = {
  __typename?: 'A2sTemplateCategory';
  abbreviation?: Maybe<Scalars['String']>;
  ability?: Maybe<Scalars['String']>;
  driver?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  questions: Array<A2sTemplateQuestion>;
};

export type A2sTemplateDefaults = {
  __typename?: 'A2sTemplateDefaults';
  questionnaireAnswers?: Maybe<A2sTemplateDefaultsAnswers>;
  report?: Maybe<A2sReport>;
  userQuestionnaires?: Maybe<A2sUserQuestionnaireConfiguration>;
};

export type A2sTemplateDefaultsAnswers = {
  __typename?: 'A2sTemplateDefaultsAnswers';
  metadataConfig?: Maybe<A2sMetadataConfiguration>;
  minAnswersToScore?: Maybe<Scalars['String']>;
  perspective?: Maybe<Scalars['String']>;
  questionContextLabel?: Maybe<Scalars['String']>;
  questionLabel?: Maybe<Scalars['String']>;
  questionTypeEnabled?: Maybe<Scalars['Boolean']>;
  rating1?: Maybe<Scalars['String']>;
  rating1Color?: Maybe<Scalars['String']>;
  rating1Disabled?: Maybe<Scalars['Boolean']>;
  rating1Title?: Maybe<Scalars['String']>;
  rating1Value?: Maybe<Scalars['Int']>;
  rating2?: Maybe<Scalars['String']>;
  rating2Color?: Maybe<Scalars['String']>;
  rating2Disabled?: Maybe<Scalars['Boolean']>;
  rating2Title?: Maybe<Scalars['String']>;
  rating2Value?: Maybe<Scalars['Int']>;
  rating3?: Maybe<Scalars['String']>;
  rating3Color?: Maybe<Scalars['String']>;
  rating3Disabled?: Maybe<Scalars['Boolean']>;
  rating3Title?: Maybe<Scalars['String']>;
  rating3Value?: Maybe<Scalars['Int']>;
  rating4?: Maybe<Scalars['String']>;
  rating4Color?: Maybe<Scalars['String']>;
  rating4Disabled?: Maybe<Scalars['Boolean']>;
  rating4Title?: Maybe<Scalars['String']>;
  rating4Value?: Maybe<Scalars['Int']>;
  rating5?: Maybe<Scalars['String']>;
  rating5Color?: Maybe<Scalars['String']>;
  rating5Disabled?: Maybe<Scalars['Boolean']>;
  rating5Title?: Maybe<Scalars['String']>;
  rating5Value?: Maybe<Scalars['Int']>;
  ratingBands?: Maybe<Array<Maybe<A2sRatingBand>>>;
  ratingIncompleteColor?: Maybe<Scalars['String']>;
  ratingNA?: Maybe<Scalars['String']>;
  ratingNAColor?: Maybe<Scalars['String']>;
  ratingNAEnabled?: Maybe<Scalars['Boolean']>;
  ratingNATitle?: Maybe<Scalars['String']>;
  ratingNAValue?: Maybe<Scalars['Int']>;
  showGuidance?: Maybe<Scalars['Boolean']>;
  useQuestionIndex?: Maybe<Scalars['Boolean']>;
  useQuestionRatingStratum?: Maybe<Scalars['Boolean']>;
  wbsEnabled?: Maybe<Scalars['Boolean']>;
};

export type A2sTemplateDeliveryGuidance = {
  __typename?: 'A2sTemplateDeliveryGuidance';
  description: Scalars['String'];
  learnMore: Scalars['String'];
};

export type A2sTemplateQuestion = {
  __typename?: 'A2sTemplateQuestion';
  abbreviation?: Maybe<Scalars['String']>;
  answerType?: Maybe<Scalars['String']>;
  artifact?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  customerRole?: Maybe<Scalars['String']>;
  dependencyActivity?: Maybe<Scalars['String']>;
  hint?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  question: Scalars['String'];
  rating1?: Maybe<Scalars['String']>;
  rating2?: Maybe<Scalars['String']>;
  rating3?: Maybe<Scalars['String']>;
  rating4?: Maybe<Scalars['String']>;
  rating5?: Maybe<Scalars['String']>;
  responseSelections?: Maybe<A2sTemplateResponseSelections>;
  targetSegmentIds?: Maybe<Array<Scalars['String']>>;
  type?: Maybe<Scalars['String']>;
  workStream?: Maybe<Scalars['String']>;
};

export type A2sTemplateResponseSelections = {
  __typename?: 'A2sTemplateResponseSelections';
  selectionDescription: Scalars['String'];
  selections: Array<A2sTemplateSelection>;
};

export type A2sTemplateSection = {
  __typename?: 'A2sTemplateSection';
  categories: Array<A2sTemplateCategory>;
  hide?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  showIfAnswerYes?: Maybe<Scalars['String']>;
};

export type A2sTemplateSectionWrapper = {
  __typename?: 'A2sTemplateSectionWrapper';
  label?: Maybe<Scalars['String']>;
  perspectives: Array<A2sTemplateSection>;
};

export type A2sTemplateSelection = {
  __typename?: 'A2sTemplateSelection';
  selectionId: Scalars['String'];
  selectionLabel: Scalars['String'];
};

export type A2sTemplateWorkstream = {
  __typename?: 'A2sTemplateWorkstream';
  accelerator?: Maybe<Scalars['String']>;
  activities: Array<A2sTemplateActivity>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type A2sUserQuestionnaireConfiguration = {
  __typename?: 'A2sUserQuestionnaireConfiguration';
  preEvent?: Maybe<A2sPreEventConfiguration>;
};

export type AddLocaleInput = {
  /** The locale to add. Should be in the form: en-US */
  locale: Scalars['String'];
  /** The template that should get the new locale */
  templateId: Scalars['ID'];
};

export type Applicability = {
  __typename?: 'Applicability';
  /** A list of conditions that determine if the current prompt is applicable in the assessment */
  applicabilityConditions: Array<ApplicabilityCondition>;
};

export type ApplicabilityCondition = {
  __typename?: 'ApplicabilityCondition';
  /** The identifier of the prompt that determines applicability. E.g. targetSegmentId */
  applicabilityPromptKey: Scalars['ID'];
  /** The responses to the above prompt, that would make the attached prompt applicable */
  applicableResponses: Array<Scalars['String']>;
};

/** AssessmentDescriptor contains localized text for the object it's associated with. E.g. a prompt descriptor contains question text */
export type AssessmentDescriptor = {
  __typename?: 'AssessmentDescriptor';
  abbreviation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptorId: Scalars['ID'];
  helpContext?: Maybe<Scalars['String']>;
  hint?: Maybe<Scalars['String']>;
  /** Locale describes which language the descriptor has text for */
  locale: Scalars['String'];
  /** Depending on what the descriptor describes, the following attributes may or may not be set. E.g. a prompt descriptor won't have an abbreviation */
  name?: Maybe<Scalars['String']>;
  templateId: Scalars['ID'];
};

export type AssessmentMetadataConfiguration = {
  __typename?: 'AssessmentMetadataConfiguration';
  /** Default metadata prompts that are excluded from this template */
  excludedMetadataPrompts?: Maybe<Array<OptionalAssessmentMetadataKey>>;
  /** Additional metadata prompts that an assessment type owner can define */
  metadataPrompts?: Maybe<Array<AssessmentPrompt>>;
  /** Default optional metadata prompts that are mandatory for this template */
  requiredMetadataPrompts?: Maybe<Array<OptionalAssessmentMetadataKey>>;
};

/** Like how a folder can contain files or folders, AssessmentModule can contain prompts or other modules */
export type AssessmentModule = {
  __typename?: 'AssessmentModule';
  /** The ID of the module that A2S uses. E.g. cloudObjectives */
  a2sId: Scalars['ID'];
  /** Any child modules. May be [] if there are none */
  childModules: Array<AssessmentModule>;
  /** The different descriptors have the module name in alternative locales */
  descriptors: Array<AssessmentDescriptor>;
  /** Any additional metadata associated with the module. E.g. ability, driver, showIfAnswerYes, hide */
  metadata?: Maybe<Array<TemplateEntityMetadata>>;
  moduleId: Scalars['ID'];
  /** The parent module of the module. May be undefined */
  parentModule?: Maybe<AssessmentModule>;
  /** The prompts in this module. May be [] if there are none */
  prompts: Array<AssessmentPrompt>;
  templateId: Scalars['ID'];
};

/** AssessmentPrompts are the actual questions in the assessment */
export type AssessmentPrompt = {
  __typename?: 'AssessmentPrompt';
  /** The ID of the prompt that A2S uses. E.g. business-cloudObjectives-1 */
  a2sId: Scalars['ID'];
  /** An association with another prompt, which determines if this prompt is applicable in the current assessment */
  applicability?: Maybe<Applicability>;
  /** The different descriptors have the question text in alternative locales */
  descriptors?: Maybe<Array<AssessmentDescriptor>>;
  /** Any additional metadata associated with the prompt. E.g. customerRole, artifact */
  metadata?: Maybe<Array<TemplateEntityMetadata>>;
  promptId: Scalars['ID'];
  /** The rating guides for this prompt, if it's a rating question */
  ratingGuide?: Maybe<RatingGuide>;
  /** The response type of this prompt */
  responseType?: Maybe<ResponseType>;
  /** The different descriptors have the selection description in alternative locales, if it's a selection question */
  selectionDescription?: Maybe<Array<AssessmentDescriptor>>;
  /** The selections available for this prompt, if it's a selection question */
  selections?: Maybe<Array<Selection>>;
  templateId: Scalars['ID'];
};

/** AssessmentTemplate contains the content for an assessment type */
export type AssessmentTemplate = {
  __typename?: 'AssessmentTemplate';
  /** Configuration of the template. Pre-event/live event, scoring bands, defaults, etc. */
  config: AssessmentTemplateConfig;
  /** Delivery guidance associated with the template */
  deliveryGuidance: Array<AssessmentDescriptor>;
  /** The different descriptors have the template name in alternative locales */
  descriptors: Array<AssessmentDescriptor>;
  templateId: Scalars['ID'];
  /** A unique acronym that describes this assessment type */
  type: Scalars['String'];
  /** The version of this assessment type. E.g. 'V1.0' */
  version: Scalars['String'];
  /** The views in this template. Each template must have at least one view */
  views: Array<AssessmentView>;
};

export type AssessmentTemplateConfig = {
  __typename?: 'AssessmentTemplateConfig';
  /** Prompts that determine applicability of other prompts. E.g. MRA2's targetSegmentId */
  applicabilityPrompts?: Maybe<Array<AssessmentPrompt>>;
  /** Assessment metadata config modifies the prompts shown on the 'Create assessment' wizard */
  assessmentMetadataConfig?: Maybe<AssessmentMetadataConfiguration>;
  defaultNamespaces: Array<AssessmentTemplateDefaultNamespace>;
  /** Prompt metadata config shows mini-prompts associated with normal prompts (e.g. CMA's ProgressToNextLevel) */
  promptMetadataConfig?: Maybe<AssessmentMetadataConfiguration>;
  /** Rating bands determine how sections/categories are shaded in the reports */
  ratingBands?: Maybe<Array<RatingBand>>;
};

/** A key-value pair indicating a default in the template */
export type AssessmentTemplateDefault = {
  __typename?: 'AssessmentTemplateDefault';
  /** Any descriptor associated with this default. A title, description, label, etc. */
  descriptors?: Maybe<Array<AssessmentDescriptor>>;
  /** The key of the default, unique to the associated namespace */
  key: Scalars['String'];
  /** The value of the default, if applicable. If an array, may be a stringified JSON. May be null if the key is associated with a descriptor */
  value?: Maybe<Scalars['String']>;
  /** The type of the value */
  valueType?: Maybe<DefaultValueType>;
};

/** A logical grouping for related defaults */
export type AssessmentTemplateDefaultNamespace = {
  __typename?: 'AssessmentTemplateDefaultNamespace';
  /** All defaults specified in the namespace */
  defaults: Array<AssessmentTemplateDefault>;
  /** The name of the namespace. pre-event, questionnaireAnswers, pptxReport, etc. */
  namespace: Scalars['String'];
};

/** AssessmentTemplateMetadata contains metadata that is relevant to assessment type owners */
export type AssessmentTemplateMetadata = {
  __typename?: 'AssessmentTemplateMetadata';
  /** Principals who can create assessments using this template */
  authorizedAssessmentCreators: Array<Scalars['String']>;
  /** Co-owners of the template */
  coowners: Array<Scalars['String']>;
  /** Unix epoch time, when this template was created */
  createdAt: Scalars['Int'];
  /** The different descriptors have the template name in alternative locales */
  descriptors: Array<AssessmentDescriptor>;
  /** Whether this template is published for the whole assessment type */
  isPublishedForType: Scalars['Boolean'];
  /** Whether this template is published for the specified version */
  isPublishedForVersion: Scalars['Boolean'];
  /** Locale managers for each locale that the template supports */
  localeManagers: Array<LocaleToLocaleManagersMapping>;
  /** Owner of this template */
  owner: Scalars['String'];
  templateId: Scalars['ID'];
  type: Scalars['String'];
  version: Scalars['String'];
};

/** AssessmentView indicates one way to view/group the modules/prompts. Different views may share the same prompts */
export type AssessmentView = {
  __typename?: 'AssessmentView';
  /** The different descriptors have the view name in alternative locales */
  descriptors: Array<AssessmentDescriptor>;
  /** The modules that are a part of this view. Should include only the top-level modules */
  modules: Array<AssessmentModule>;
  templateId: Scalars['ID'];
  viewId: Scalars['ID'];
};

export type CreateOrUpdateDefaultInput = {
  /** Any descriptor that should be associated with this default. A title, description, label, etc. */
  descriptors?: InputMaybe<Array<Scalars['ID']>>;
  /** The referenceable name of the default. E.g. rating1Disabled */
  key: Scalars['String'];
  /** The namespace in which the default should be created/updated */
  namespace: Scalars['String'];
  /** The template in which the default should be created/updated */
  templateId: Scalars['ID'];
  /** The value of the default, if applicable */
  value?: InputMaybe<Scalars['String']>;
  /** The type of the value; how it should be parsed/interpreted. If value is provided, then valueType must be provided too */
  valueType?: InputMaybe<DefaultValueType>;
};

export type CreateTemplateInput = {
  /** ID of the published template, from which the new draft should be created */
  baseTemplateId: Scalars['ID'];
};

/** Describes the type of the associated value */
export enum DefaultValueType {
  Boolean = 'Boolean',
  Number = 'Number',
  String = 'String'
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  body?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type GetTemplatesFilter = {
  /** If a locale is specified, will retrieve descriptors only for that locale. Otherwise, get all descriptors */
  locale?: InputMaybe<Scalars['String']>;
  /** If metadataFilters is specified, will retrieve the latest templates for the specified type/version */
  metadataFilters?: InputMaybe<Array<TemplateMetadataFilter>>;
  /** If templateIds is specified, will retrieve those templates */
  templateIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Because GraphQL doesn't have a Map type, need an array of tuples to define locale managers for each locale */
export type LocaleToLocaleManagersMapping = {
  __typename?: 'LocaleToLocaleManagersMapping';
  locale: Scalars['String'];
  localeManagers: Array<Scalars['String']>;
};

export type MetadataDefinition = {
  __typename?: 'MetadataDefinition';
  defaultValue?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  keyDescription?: Maybe<Scalars['String']>;
  keyName: Scalars['String'];
  responseSelections?: Maybe<A2sTemplateResponseSelections>;
  valueHint?: Maybe<Scalars['String']>;
  valueType?: Maybe<MetadataValueType>;
};

export enum MetadataValueType {
  DateValue = 'dateValue',
  SingleSelection = 'singleSelection',
  Text = 'text',
  Yesno = 'yesno'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Enables another locale in a template. Echoes back template ID once complete */
  addLocale?: Maybe<Scalars['ID']>;
  /** Creates or updates a default associated with the template. Returns the new default */
  createOrUpdateDefault?: Maybe<AssessmentTemplateDefault>;
  /** Creates a draft from the specified published template */
  createTemplate?: Maybe<AssessmentTemplateMetadata>;
  /** Publishes a template. Returns the new metadata */
  publishTemplate?: Maybe<AssessmentTemplate>;
  /** Shares an assessment type. Echoes back the assessment type acronym if successful */
  shareAssessmentType?: Maybe<Scalars['String']>;
  /** Shares a template. Echoes back the template ID if successful */
  shareTemplate?: Maybe<Scalars['ID']>;
  /** Removes permissions from an assessment type. Echoes back the assessment type acronym if successful */
  unshareAssessmentType?: Maybe<Scalars['String']>;
  /** Removes permissions from a template. Echoes back the template ID if successful */
  unshareTemplate?: Maybe<Scalars['ID']>;
  /** Updates a descriptor. Returns the updated descriptor */
  updateDescriptor?: Maybe<AssessmentDescriptor>;
  /** Updates a prompt. Can change response type or add/remove selections */
  updatePrompt?: Maybe<AssessmentPrompt>;
  /** Create a new template using a stringified JSON */
  uploadTemplate?: Maybe<Scalars['ID']>;
};


export type MutationAddLocaleArgs = {
  input: AddLocaleInput;
};


export type MutationCreateOrUpdateDefaultArgs = {
  input: CreateOrUpdateDefaultInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationPublishTemplateArgs = {
  input: PublishTemplateInput;
};


export type MutationShareAssessmentTypeArgs = {
  input: ShareAssessmentTypeInput;
};


export type MutationShareTemplateArgs = {
  input: ShareTemplateInput;
};


export type MutationUnshareAssessmentTypeArgs = {
  input: UnshareAssessmentTypeInput;
};


export type MutationUnshareTemplateArgs = {
  input: UnshareTemplateInput;
};


export type MutationUpdateDescriptorArgs = {
  input: UpdateDescriptorInput;
};


export type MutationUpdatePromptArgs = {
  input: UpdatePromptInput;
};


export type MutationUploadTemplateArgs = {
  input: UploadTemplateInput;
};

export enum OptionalAssessmentMetadataKey {
  InternalContact = 'internalContact',
  MapProgramEngagementId = 'mapProgramEngagementId',
  OpportunityId = 'opportunityId',
  ReadoutDate = 'readoutDate',
  WorkshopDate = 'workshopDate'
}

export type PrincipalIdToAssessmentTypeActionMapping = {
  assessmentTypeAction: ShareableAssessmentTypeAction;
  principalId: Scalars['String'];
};

export type PrincipalIdToTemplateActorMapping = {
  /** If templateActor is a LocaleManager, grants management for the below locale */
  locale?: InputMaybe<Scalars['String']>;
  principalId: Scalars['String'];
  templateActor: ShareableTemplateActor;
};

export type PublishTemplateInput = {
  /** Whether the template should be made the primary template for the whole assessment type */
  publishForType?: InputMaybe<Scalars['Boolean']>;
  /** The template to publish */
  templateId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  /** Same as getTemplates, but returns the templates in the A2S schema */
  getA2sTemplates: Array<A2sTemplate>;
  /** Gets certain templates. Either templateIds or metadataFilter must be provided */
  getTemplates: Array<AssessmentTemplate>;
  /** Lists all the templates that the user can edit */
  listEditableTemplates: Array<AssessmentTemplateMetadata>;
  /** Lists the published templates from which the calling user can create an assessment */
  listTemplates: Array<AssessmentTemplate>;
};


export type QueryGetA2sTemplatesArgs = {
  filter: GetTemplatesFilter;
};


export type QueryGetTemplatesArgs = {
  filter: GetTemplatesFilter;
};

/** A rating band provides a title, description, and hex color for a score between [lowerBound, upperBound) */
export type RatingBand = {
  __typename?: 'RatingBand';
  /** Hex color asscoiated with this rating */
  color?: Maybe<Scalars['String']>;
  /** Any descriptors that may be displayed if a score lands within this rating band */
  descriptors?: Maybe<Array<AssessmentDescriptor>>;
  /** Inclusive lower bound for this rating band */
  lowerBound?: Maybe<Scalars['Float']>;
  /** Exclusive upper bound for this rating band */
  upperBound?: Maybe<Scalars['Float']>;
};

export type RatingGuide = {
  __typename?: 'RatingGuide';
  /** Guides for each rating. Different descriptors contain the guide text in different locales */
  guide1?: Maybe<Array<AssessmentDescriptor>>;
  guide2?: Maybe<Array<AssessmentDescriptor>>;
  guide3?: Maybe<Array<AssessmentDescriptor>>;
  guide4?: Maybe<Array<AssessmentDescriptor>>;
  guide5?: Maybe<Array<AssessmentDescriptor>>;
};

export enum ResponseType {
  DateValue = 'DATE_VALUE',
  MultiSelection = 'MULTI_SELECTION',
  Number = 'NUMBER',
  Rating = 'RATING',
  SingleSelection = 'SINGLE_SELECTION',
  Text = 'TEXT',
  YesNo = 'YES_NO'
}

export type Selection = {
  __typename?: 'Selection';
  selectionId: Scalars['ID'];
  /** The selection text in different locales */
  selectionLabel?: Maybe<Array<AssessmentDescriptor>>;
};

export type ShareAssessmentTypeInput = {
  assessmentTypeAcronym: Scalars['String'];
  newPermissions: Array<PrincipalIdToAssessmentTypeActionMapping>;
};

export type ShareTemplateInput = {
  newPermissions: Array<PrincipalIdToTemplateActorMapping>;
  templateId: Scalars['String'];
};

export enum ShareableAssessmentTypeAction {
  Access = 'Access'
}

export enum ShareableTemplateActor {
  CoOwner = 'CoOwner',
  LocaleManager = 'LocaleManager'
}

/** Arbitrary Metadata about an entity within a template (prompt, module). Stored in template management, but determines behavior only on front-end */
export type TemplateEntityMetadata = {
  __typename?: 'TemplateEntityMetadata';
  descriptors?: Maybe<Array<AssessmentDescriptor>>;
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type TemplateMetadataFilter = {
  /** The unique assessment type acronym. If version is not specified, will retrieve the template that is publishedForType */
  type: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};

export type UnshareAssessmentTypeInput = {
  assessmentTypeAcronym: Scalars['String'];
  permissionsToRemove: Array<PrincipalIdToAssessmentTypeActionMapping>;
};

export type UnshareTemplateInput = {
  permissionsToRemove: Array<PrincipalIdToTemplateActorMapping>;
  templateId: Scalars['String'];
};

export type UpdateDescriptorInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** The descriptor to update */
  descriptorId: Scalars['ID'];
  helpContext?: InputMaybe<Scalars['String']>;
  hint?: InputMaybe<Scalars['String']>;
  /** The locale of the descriptor to update */
  locale: Scalars['String'];
  /** Can update any/all of the below attributes */
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePromptInput = {
  /** Whether a new selection should be added */
  addSelection?: InputMaybe<Scalars['Boolean']>;
  /** The prompt to update */
  promptId: Scalars['ID'];
  /** The new response type */
  responseType?: InputMaybe<ResponseType>;
  /** The selection to remove, if applicable */
  selectionIdToRemove?: InputMaybe<Scalars['ID']>;
};

export type UploadTemplateInput = {
  /** Stringified JSON template */
  template: Scalars['String'];
};
